import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { LOADING } from '../../../../../constants/common-labels.constants';
import './hub-embed.scss';

type HubEmbedProps = {
    url: string | null;
    refreshKey?: number;
    isRefreshing?: boolean;
};

export const HubEmbed = ({ url, refreshKey = 0, isRefreshing = false }: HubEmbedProps) => {
    const [loadedRefreshKey, setLoadedRefreshKey] = useState<number | null>(null);

    useEffect(() => {
        if (isRefreshing) {
            setLoadedRefreshKey(null);
        }
    }, [isRefreshing]);

    if (!url) {
        return <div className='hub-embed hub-embed--empty' />;
    }

    const showLoadingOverlay = isRefreshing || loadedRefreshKey !== refreshKey;

    return (
        <div className='hub-embed-container'>
            {showLoadingOverlay && (
                <div className='hub-embed hub-embed--loading'>
                    <FormattedMessage {...LOADING} values={{ suffix: '...' }} />
                </div>
            )}
            {!isRefreshing && (
                <iframe
                    key={refreshKey}
                    className='hub-embed'
                    src={url}
                    title='Hub Embed'
                    onLoad={() => setLoadedRefreshKey(refreshKey)}
                />
            )}
        </div>
    );
};
